module.exports = __webpack_public_path__ + "media/src/application/media/animation/road-str-71dadf8851d72afb9077dc27897219a0.svg";